/**
 * Copy-to-clipboard icon button for arbitrary text (chat answers, SQL
 * blocks). Sibling of CopyIdButton, with text-generic toasts; stops click
 * propagation so it can live inside clickable containers.
 */
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";
import { useToast } from "../../hooks/useToast";

export function CopyTextButton({ value, label }: { value: string; label: string }) {
  const { t } = useTranslation();
  const toast = useToast();

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      toast(t("common.textCopied"), "success");
    } catch {
      toast(t("common.textCopyFailed"), "error");
    }
  }

  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        aria-label={label}
        onClick={(e) => {
          e.stopPropagation();
          void copy();
        }}
      >
        <ContentCopyIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
}
